const filterSupplierRootDescExclusions = {
    FRA: {
        filters: ['-%IMT %', '-%CARREFOUR EUROPE TRA%'],
        onlyForScope: 'external'
    },
    ESP: {
        filters: ['-%IMT %', '-%CARREFOUR EUROPE TRA%'],
        onlyForScope: 'external'
    },
    BEL: {
        filters: ['-%IMT %', '-%CARREFOUR EUROPE TRADING SAS%'],
        onlyForScope: 'external'
    }
};
// The constant below define explicitly static filters for each defined view.
// These filters are not dynamic and are added directly to the Looker request per view.
// If a view is defined here, all requests for that view will include the specified filters.
// - If the filter configuration is nested under a **country code** (e.g., `FRA`),
//   it applies **only to that specific country**.
// - `filter`: the actual Looker filter value applied to the field
// - `onlyForScope`: restricts the filter to internal or external users
// In case no restrictions defined the filter will get included by default
export const LOOKER_STATIC_FILTER_PER_VIEW = {
    competitor_sales_crf_global: {
        filter_supplier_root_desc: {
            ...filterSupplierRootDescExclusions
        }
    },
    competitor_supplier_market_share_crf_global: {
        filter_supplier_root_desc: {
            ...filterSupplierRootDescExclusions
        }
    },
    competitor_numerical_distribution_crf_global: {
        filter_supplier_root_desc: {
            ...filterSupplierRootDescExclusions
        }
    },
    competitor_weighted_distribution_crf_global: {
        filter_supplier_root_desc: {
            ...filterSupplierRootDescExclusions
        }
    },
    shopper_migration_crf_global: {
        filter_supplier_root_desc: {
            ...filterSupplierRootDescExclusions
        }
    },
    shopper_migration_benchmark_crf_global: {
        filter_supplier_root_desc: {
            ...filterSupplierRootDescExclusions
        }
    }
};
//# sourceMappingURL=lookerStaticFilter.constant.js.map